import React from 'react';
import PropTypes from 'prop-types';

const StoreDirection = ({ mapUrl, getDirectionsText }) => (
  <div className="single-store__info-directions">
    <a href={mapUrl} target="_blank" data-property={getDirectionsText.key} rel="noreferrer">{getDirectionsText.value}</a>
  </div>
);

StoreDirection.propTypes = {
  mapUrl: PropTypes.string.isRequired,
  getDirectionsText: PropTypes.shape({
    key: PropTypes.string,
    value: PropTypes.string,
  }).isRequired,
};

export default StoreDirection;
